import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectDestructuringEmpty from "@babel/runtime-corejs2/helpers/esm/objectDestructuringEmpty";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
export var WM_LEGACY_TRIGGER = 'WM_LEGACY';

var WelcomeMessagesLegacyTrigger = /*#__PURE__*/function () {
  function WelcomeMessagesLegacyTrigger(_ref, dependencies) {
    _objectDestructuringEmpty(_ref);

    _classCallCheck(this, WelcomeMessagesLegacyTrigger);

    _defineProperty(this, "dependencies", void 0);

    this.dependencies = dependencies;
  }

  _createClass(WelcomeMessagesLegacyTrigger, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.dependencies['account-actions'].onActionRequested(function (_ref2) {
                  var actionId = _ref2.actionId,
                      data = _ref2.data;

                  if (actionId === ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPEN) {
                    _this.dependencies['on-site-messaging-component'].requestMessage({
                      trigger: WM_LEGACY_TRIGGER,
                      data: data
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return WelcomeMessagesLegacyTrigger;
}();

export default WelcomeMessagesLegacyTrigger;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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